import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React from 'react';
import invariant from 'tiny-invariant';
var TYPE_LOCALE = 'locale';
var TYPE_SUPPLEMENTAL = 'supplemental';
export default function useCldrDataReducer(type, map) {
  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  invariant([TYPE_SUPPLEMENTAL, TYPE_LOCALE].includes(type), "Type '".concat(type, "' is not supported by 'useCldrDataReducer'"));
  invariant(map, "Property 'map' is required by 'useCldrDataReducer'");
  return React.useMemo(function () {
    var cfg = type === TYPE_LOCALE ? {
      number: ['numbersLocale'],
      currency: ['currenciesLocale', 'numbersLocale'],
      plural: [],
      units: ['unitsLocale', 'numbersLocale'],
      date: ['gregorianLocale', 'timeZoneNamesLocale', 'numbersLocale'],
      relativeTime: ['dateFieldsLocale', 'numbersLocale'],
      territories: ['territoriesLocale']
    } : {
      number: ['numberingSystems'],
      currency: ['currencyData', 'numberingSystems'],
      plural: ['plurals', 'ordinals'],
      units: ['numberingSystems', 'plurals', 'ordinals'],
      date: ['metaZones', 'timeData', 'weekData', 'numberingSystems'],
      relativeTime: ['numberingSystems', 'plurals', 'ordinals']
    };

    var uniq = function uniq(arr) {
      return arr.reduce(function (a, item) {
        return a.includes(item) ? a : [].concat(_toConsumableArray(a), [item]);
      }, []);
    };

    var pipe = function pipe() {
      for (var _len = arguments.length, fncs = new Array(_len), _key = 0; _key < _len; _key++) {
        fncs[_key] = arguments[_key];
      }

      return function (v) {
        return fncs.reduce(function (r, fn) {
          return fn(r);
        }, v);
      };
    };

    var select = function select(disabled) {
      var set = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return function (x) {
        return disabled ? x : [].concat(_toConsumableArray(x), _toConsumableArray(set));
      };
    };

    var mapTps = function mapTps(tps) {
      return tps.reduce(function (a, t) {
        return map[t] ? [].concat(_toConsumableArray(a), [map[t]]) : a;
      }, []);
    };

    return pipe(select(filter.disableNumber, cfg.number), select(filter.disableCurrency, cfg.currency), select(filter.disablePlural, cfg.plural), select(filter.disableUnits, cfg.units), select(filter.disableDate, cfg.date), select(filter.disableRelativeTime, cfg.relativeTime), select(filter.disableTerritories, cfg.territories), uniq, mapTps)([]);
  }, [type, map, filter]);
}
useCldrDataReducer.TYPE_LOCALE = TYPE_LOCALE;
useCldrDataReducer.TYPE_SUPPLEMENTAL = TYPE_SUPPLEMENTAL;